export default __webpack_public_path__ + "static/media/No46Closed.abb9dc38.jpg";